import React from "react";

export const AuthController = (props) => {
  const { userTypes = [], children } = props;
  const userType = localStorage.getItem("userType");

  const isAuthorized = userTypes.includes(userType?.toUpperCase());

  if (isAuthorized) {
    return <>{children}</>;
  } else {
    return <> </>;
  }
};
